import React from "react";
import { Grid, Link, makeStyles } from "@material-ui/core";
import acuityLogo from ".././../Images/acuity-coaching-simple-logo2.svg";
import { Typography } from "@material-ui/core";
function Footer() {
  const classes = useStyles();

  const links = [
    { name: "Terms", path: "https://www.acuitycoaching.com/terms-of-use" },
    { name: "Privacy and Cookies Policy", path: "https://www.acuitycoaching.com/privacy-and-cookies-policy" },
    { name: "Acuity Coaching Limited", path: "https://www.acuitycoaching.com/" },
    // { name: "Query", path: "#" },
  ];

  return (
    <footer className={classes.container}>
      <Grid
        container
        style={{ height: "100%" }}
        direction="row"
        alignItems="center"
        justify="center"
      > <img src={acuityLogo} alt="acuitylogo" style={{ width: 150, borderRadius: '5px' }} />
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
          item
          xs={10}
        >{" "}
          <Typography variant="h2">
            {links.map((e, i) => (
              <Link
                href={e.path}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  paddingLeft: i === 1 && 1,
                  borderRight:
                    links.length - 1 === i ? "none" : "1px solid #fff",
                }}
                className={classes.link}
                key={i}
              >{" "}
                {e.name}
              </Link>
            ))}
          </Typography>

          <Typography variant="h2" className={classes.link}>
            &copy; {new Date().getFullYear()} All rights reserved
          </Typography>
        </Grid>
      </Grid>
    </footer>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "58px",
    backgroundColor: "#077F83",
  },
  link: {
    fontSize: "16px",
    color: "#fff",
    padding: "0 10px",
  },
}));

export default Footer;
